import { render, staticRenderFns } from "./salesReturnReceivingRecord.vue?vue&type=template&id=61c9379b"
import script from "./salesReturnReceivingRecord.vue?vue&type=script&lang=js"
export * from "./salesReturnReceivingRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports